var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d;
import { Expose } from 'class-transformer';
import { EFileExtension, EFileSubType, EFileType } from '~/shared/types';
export class ModelBookContentSectionContent {
    cdate;
    id;
    mdate;
    order;
    sectionId;
    text;
    communityId;
    description;
    eventId;
    fileExtension;
    folderId;
    hasWatermark;
    hash;
    isCleanup;
    isConverted;
    itemId;
    name;
    objType;
    origExtension;
    originalId;
    path;
    resolution;
    state;
    subType;
    syncAllowChange;
    syncId;
    time;
    userId;
    weight;
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentSectionContent.prototype, "cdate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentSectionContent.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentSectionContent.prototype, "mdate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentSectionContent.prototype, "order", void 0);
__decorate([
    Expose({ name: 'section_id' }),
    __metadata("design:type", String)
], ModelBookContentSectionContent.prototype, "sectionId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBookContentSectionContent.prototype, "text", void 0);
__decorate([
    Expose({ name: 'community_id' }),
    __metadata("design:type", Number)
], ModelBookContentSectionContent.prototype, "communityId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBookContentSectionContent.prototype, "description", void 0);
__decorate([
    Expose({ name: 'event_id' }),
    __metadata("design:type", Object)
], ModelBookContentSectionContent.prototype, "eventId", void 0);
__decorate([
    Expose({ name: 'file_extension' }),
    __metadata("design:type", typeof (_a = typeof EFileExtension !== "undefined" && EFileExtension) === "function" ? _a : Object)
], ModelBookContentSectionContent.prototype, "fileExtension", void 0);
__decorate([
    Expose({ name: 'folder_id' }),
    __metadata("design:type", Number)
], ModelBookContentSectionContent.prototype, "folderId", void 0);
__decorate([
    Expose({ name: 'has_watermark' }),
    __metadata("design:type", Number)
], ModelBookContentSectionContent.prototype, "hasWatermark", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelBookContentSectionContent.prototype, "hash", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentSectionContent.prototype, "isCleanup", void 0);
__decorate([
    Expose({ name: 'is_converted' }),
    __metadata("design:type", Number)
], ModelBookContentSectionContent.prototype, "isConverted", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentSectionContent.prototype, "itemId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBookContentSectionContent.prototype, "name", void 0);
__decorate([
    Expose({ name: 'obj_type' }),
    __metadata("design:type", typeof (_b = typeof EFileType !== "undefined" && EFileType) === "function" ? _b : Object)
], ModelBookContentSectionContent.prototype, "objType", void 0);
__decorate([
    Expose({ name: 'orig_extension' }),
    __metadata("design:type", typeof (_c = typeof EFileExtension !== "undefined" && EFileExtension) === "function" ? _c : Object)
], ModelBookContentSectionContent.prototype, "origExtension", void 0);
__decorate([
    Expose({ name: 'original_id' }),
    __metadata("design:type", Number)
], ModelBookContentSectionContent.prototype, "originalId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBookContentSectionContent.prototype, "path", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBookContentSectionContent.prototype, "resolution", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBookContentSectionContent.prototype, "state", void 0);
__decorate([
    Expose({ name: 'sub_type' }),
    __metadata("design:type", typeof (_d = typeof EFileSubType !== "undefined" && EFileSubType) === "function" ? _d : Object)
], ModelBookContentSectionContent.prototype, "subType", void 0);
__decorate([
    Expose({ name: 'sync_allow_change' }),
    __metadata("design:type", Number)
], ModelBookContentSectionContent.prototype, "syncAllowChange", void 0);
__decorate([
    Expose({ name: 'sync_id' }),
    __metadata("design:type", Object)
], ModelBookContentSectionContent.prototype, "syncId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelBookContentSectionContent.prototype, "time", void 0);
__decorate([
    Expose({ name: 'user_id' }),
    __metadata("design:type", Number)
], ModelBookContentSectionContent.prototype, "userId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentSectionContent.prototype, "weight", void 0);
